import { render } from "./ContactAssociationsDisplay.vue?vue&type=template&id=ebe095e2&scoped=true"
import script from "./ContactAssociationsDisplay.vue?vue&type=script&lang=js"
export * from "./ContactAssociationsDisplay.vue?vue&type=script&lang=js"

import "./ContactAssociationsDisplay.vue?vue&type=style&index=0&id=ebe095e2&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebe095e2"]])

export default __exports__